module.exports = {"341321100":"砀城镇","341321101":"赵屯镇","341321102":"李庄镇","341321103":"唐寨镇","341321104":"葛集镇","341321105":"周寨镇","341321106":"玄庙镇","341321107":"官庄坝镇","341321108":"曹庄镇","341321109":"关帝庙镇","341321110":"朱楼镇","341321111":"良梨镇","341321112":"程庄镇","341321400":"经济开发区","341321401":"薛楼板材加工园","341321402":"高铁新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341321.json
// module id = 1131
// module chunks = 0